module.exports = __webpack_public_path__ + "static/media/userIcon.c6731f50.svg";